import DisplayDropzoneFile from './DisplayDropzoneFile.component';

export default DisplayDropzoneFile;